import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '../views/Login.vue'
// import SignUp from '../views/SignUp.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/Login',
    name: 'Login',
    component: Login
  },
  // {
  //   path: '/SignUp',
  //   name: 'SignUp',
  //   component: SignUp,
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
